import { render, staticRenderFns } from "./dashboard-header.vue?vue&type=template&id=58cd5435&"
import script from "./dashboard-header.vue?vue&type=script&lang=tsx&"
export * from "./dashboard-header.vue?vue&type=script&lang=tsx&"
import style0 from "./dashboard-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports